<app-header></app-header>
<div class="contenedor_principal">
    <app-menu-alterno></app-menu-alterno>
    <div class="contenidoDivTitulo">
        <div class="div-titulo-seccion">
            <h1 class="h1-titulo-app" [innerHTML]="constantes.ETIQUETA_BOTON_DETALLE_CATALOGO"></h1>
        </div>
        <div class="div-linea-titulo"></div>
    </div>
    <div>
        <div id="thumbnail-slider">
            <div style="width: 33%;">
                <div class="div-cuadro-busqueda">
                    <input #myInput type="text" id="myInput" (keyup)="filtrar(myInput.value)" class="input-text"
                        placeholder="Buscar en el catálogo de variables / temáticas"
                        title="Escriba una palabra clave"><input class="input-button" type="image"
                        src="/estadisticas-economicas/assets/img/iconos/search.png" (click)="filtrar(myInput.value)" />
                </div>
            </div>
            <div class="inner" id="menu-estadisticas-slider">
                <div class="div-principal">
                    <div class="container-tabla">
                        <table mat-table [dataSource]="seriesTematicasDisponiblesFiltrada">
                            <ng-container matColumnDef="serie" sticky>
                                <th mat-header-cell *matHeaderCellDef> <span class="titulo-encabezado-detalle">Variable / Temática</span> </th>
                                <td mat-cell *matCellDef="let serie"> {{serie.descripcion}} </td>
                            </ng-container>
                            <ng-container matColumnDef="buscadorSeries">
                                <th mat-header-cell *matHeaderCellDef>
                                    <a (click)="irBuscadorSeries()" class="enlaceProducto titulo-encabezado-detalle">Descarga múltiple de datos</a>
                                </th>
                                <td mat-cell *matCellDef="let serie"> 
                                    <img *ngIf="serie.buscadorSeries === 'SI'" src="{{ getImage(serie.buscadorSeries) }}" width="25px" (click)="irBuscadorSeries('_blank')" class="pointer">
                                    <img *ngIf="serie.buscadorSeries !== 'SI'" src="{{ getImage(serie.buscadorSeries) }}" width="25px">
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="graficadorSeries">
                                <th mat-header-cell *matHeaderCellDef>
                                    <a (click)="irGraficasInteractivas()" class="enlaceProducto titulo-encabezado-detalle">Graficador de series</a>
                                </th>
                                <td mat-cell *matCellDef="let serie">
                                    <a *ngIf="serie.graficadorSeries === 'SI'" href="/graficador-series/#/grafica/{{serie.id}}" target="_blank">
                                        <img src="{{ getImage(serie.graficadorSeries) }}" width="25px">
                                    </a>
                                    <img *ngIf="serie.graficadorSeries !== 'SI'" src="{{ getImage(serie.graficadorSeries) }}" width="25px">
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="indicadoresDiarios">
                                <th mat-header-cell *matHeaderCellDef>
                                    <a (click)="irIndicadoresEconomicosDia()" class="enlaceProducto titulo-encabezado-detalle"> Indicadores económicos del día </a>
                                </th>
                                <td mat-cell *matCellDef="let serie">
                                    <img *ngIf="serie.indicadoresDiarios === 'SI'" src="{{ getImage(serie.indicadoresDiarios) }}" width="25px" (click)="irIndicadoresEconomicosDia('_blank')" class="pointer">
                                    <img *ngIf="serie.indicadoresDiarios !== 'SI'" src="{{ getImage(serie.indicadoresDiarios) }}" width="25px">
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="tablasPreconstruidas">
                                <th mat-header-cell *matHeaderCellDef>
                                    <a (click)="irTablasPreconstruidas()" class="enlaceProducto titulo-encabezado-detalle"> Tablas preconstruidas </a>
                                </th>
                                <td mat-cell *matCellDef="let serie">
                                    <img *ngIf="serie.tablasPreconstruidas === 'SI'" src="{{ getImage(serie.tablasPreconstruidas) }}" width="25px" (click)="irTablasPreconstruidas('_blank')" class="pointer">
                                    <img *ngIf="serie.tablasPreconstruidas !== 'SI'" src="{{ getImage(serie.tablasPreconstruidas) }}" width="25px" >
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="cabecera"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index" [ngClass]="{'cabecera-tematica': !row.tipo && !row.serieTematicaPadre, 'interlineado': (row.tipo || (!row.tipo && row.serieTematicaPadre)) && i%2===0 }"></tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>